import { useLanguage } from '@/contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import FadeIn from '@/components/FadeIn';
import { Mail, Phone } from 'lucide-react';

export default function ContatoSection() {
  const { language, t } = useLanguage();
  const navigate = useNavigate();

  return (
    <section
      id="contato"
      data-testid="section-contato"
      className="min-h-screen flex flex-col justify-center px-8 md:px-16 lg:px-24 py-24 relative"
    >
      {/* Subtle organic shape */}
      <svg
        className="absolute top-32 right-4 w-40 h-40 opacity-[0.04] pointer-events-none"
        viewBox="0 0 200 200"
      >
        <circle cx="100" cy="100" r="85" fill="#F7AFA8" />
      </svg>

      <FadeIn>
        <h2
          data-testid="contato-title"
          className="text-3xl md:text-4xl lg:text-5xl font-light text-[#873D77] tracking-tight leading-tight mb-8"
        >
          {t.contato.title}
        </h2>
      </FadeIn>

      <FadeIn delay={0.2}>
        <p
          data-testid="contato-content"
          className="text-base md:text-lg font-light text-[#333333]/90 leading-relaxed max-w-xl mb-12"
        >
          {t.contato.content}
        </p>
      </FadeIn>

      {/* Contact icon - mail + phone combined */}
      <FadeIn delay={0.4}>
        <button
          data-testid="contact-action-btn"
          aria-label={language === 'pt' ? 'Entrar em contato' : 'Contact us'}
          className="group flex items-center gap-4 p-6 rounded-2xl bg-[#F3F1EC]/60 border border-[#333333]/5 hover:border-[#35589B]/20 transition-all duration-500 cursor-pointer"
          onClick={() => navigate('/contato')}
        >
          <div className="flex items-center gap-2">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#35589B]/10 to-[#C2A8F7]/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
              <Mail
                size={20}
                className="text-[#35589B]/70 group-hover:text-[#35589B] transition-colors duration-500"
              />
            </div>
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#F8C3A8]/20 to-[#35589B]/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
              <Phone
                size={20}
                className="text-[#35589B]/70 group-hover:text-[#35589B] transition-colors duration-500"
              />
            </div>
          </div>
        </button>
      </FadeIn>
    </section>
  );
}
